import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataLoader from "../../../../Utils/DataLoader.jsx";
import { members_all, impersonate_student } from "../../../../apis/studentManagement/StudentManagement";
// import CustomTable from "../../pages/CustomTable";
import { member_destroy } from "../../../../apis/studentManagement/StudentManagement";
import { STUDENT_PORTAL_URL } from "../../../../constants/Matcher";
import { formatCourseNames, formatDate, getUserPermission } from "../../../../Utils/Utils.js";
import CustomTable from "../../../../componrnt/pages/CustomTable.jsx";
import EnrolledTerms, { FreeAssessmentTag, enrolledHeading } from "../../../../componrnt/pages/studentManagement/EnrolledTerms.jsx";
const Student_enroll_list = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const permission = getUserPermission("Students");
  const branchId = localStorage.getItem("b_id");
  const columns = [
    {
      name: "No.",
      selector: "no",
      sortable: true,
    },
    {
      name: "Name",
      selector: "first_name",
      sortable: true,
      cell: (r) => (
        <span>
          {r.first_name}
          {r.student_type === "0" ? <FreeAssessmentTag /> : null}
        </span>
      ),
    },
    {
      name: "Grade",
      selector: "grade",
      sortable: true,
    },
    {
      name: "Branch",
      selector: "branch",
      sortable: true,
    },
    {
      name: "Registered",
      selector: "date",
      sortable: true,
      // the cell shows dd-mm-yyyy; sort on the stored timestamp
      sortFunction: (a, b) => String(a.created_raw || "").localeCompare(String(b.created_raw || "")),
    },
    {
      name: enrolledHeading,
      minWidth: "240px",
      cell: (r) => <EnrolledTerms enrolled={r.enrolled_terms} />,
      sortable: true,
      // most terms in a class first
      sortFunction: (a, b) => (a.enrolled_terms?.length || 0) - (b.enrolled_terms?.length || 0),
    },
    {
      name: "Course",
      selector: "course",
      sortable: true,
    },
    {
      name: "Status",
      selector: "delete_status",
      sortable: true,
    },
    permission?.edit === 1 || permission?.delete === 1 || permission?.view === 1
      ? {
          name: "Action",
          selector: "action",
        }
      : "",
  ];
  useEffect(() => {
    const branch_id = localStorage.getItem("b_id");
    async function get_data() {
      const result = await members_all(branch_id);
      const arrayData = result?.data?.map((elem, index) => {
        const {
          id,
          first_name,
          last_name,
          subject,
          branch_name,
          grade_name,
          user_id,
          status,
          created_at,
          student_type,
          class_id,
          course_name,
          s_id,
          enrolled_terms,
        } = elem;
        return {
          no: `#${index + 1}`,
          first_name: [first_name, last_name].filter(Boolean).join(" "),
          grade: `Year ${grade_name}`,
          subject: subject ? subject : "-",
          branch: branch_name,
          student_type,
          enrolled_terms: enrolled_terms || [],
          date: formatDate(created_at),
          created_raw: created_at,
          status_data: status,
          delete_status: (
            <select
              className="form-select"
              onChange={(e) => destroy(id, e.target.value)}
              value={status}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          ),
          class_id: class_id == null ? 0 : 1,
          // course: course_name ? course_name : "-",
          course: (
            <div className="course-container">
              <span className="course-text">
                {formatCourseNames(course_name)}
              </span>
              {course_name.split(", ").length > 1 && (
                <div className="tooltip-content">{course_name}</div>
              )}
            </div>
          ),
          action: (
            <>
              {" "}
              <div data-tag="allowRowEvents">
                {permission?.view === 1 ? (
                  <Link
                    className="edit-btn"
                    to={`/branch/enroll/student_enroll-view/${s_id}`}
                  >
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </Link>
                ) : (
                  ""
                )}
                {permission?.edit === 1 ? (
                  class_id == 0 ? (
                    <Link
                      className="edit-btn"
                      to={`/branch/enroll/member-edit/${user_id}`}
                    >
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </Link>
                  ) : (
                    <button
                      className="dlt-btn"
                      onClick={() => editStudent(class_id, user_id)}
                    >
                      {" "}
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  )
                ) : (
                  ""
                )}
                {permission?.edit === 1 ? (
                  <Link
                    className="edit-btn"
                    to={`/branch/class-management/enroll/${s_id}`}
                    title="Enroll in Course"
                  >
                    <i class="fa fa-book" aria-hidden="true"></i>
                  </Link>
                ) : (
                  ""
                )}
                {permission?.view === 1 && status == 1 ? (
                  <button
                    className="dlt-btn"
                    title="Login as Student"
                    onClick={() => handleImpersonate(user_id)}
                  >
                    <i class="fa fa-right-to-bracket" aria-hidden="true"></i>
                  </button>
                ) : (
                  ""
                )}
              </div>
            </>
          ),
        };
      });
      setData(arrayData, setShowResults(true));
    }
    const destroy = async (id, status, name) => {
      const dataa = { status: status };
      const result = window.confirm(
        `${
          status == 1
            ? "Are you sure you want to active this student ?"
            : "Are you sure you want to inactive this student ? "
        }`
      );
      if (result) {
        const res = await member_destroy(id, dataa);
        console.log("res", res);
        if (res?.data) {
          get_data();
        }
      }
      get_data();
    };
    const editStudent = async (class_id, user_id) => {
      if (class_id !== null) {
        const result = window.confirm(
          "This student is already enrolled in the class. Are you sure you want to proceed with editing it?"
        );
        if (!result) {
          return;
        }
      }
      navigate(`/branch/enroll/member-edit/${user_id}`);
    };
    const handleImpersonate = async (studentUserId) => {
      const res = await impersonate_student(studentUserId);
      if (res?.status && res?.data) {
        const encoded = btoa(JSON.stringify(res.data));
        window.open(`${STUDENT_PORTAL_URL}/impersonate?data=${encoded}`, '_blank');
      }
    };
    get_data();
  }, []);

  return (
    <div className="right-nav" id="dash-event">
      {showResults ? (
        <>
          <div className="row">
            <div className="col-md-4">
              <h4 className="modal-title">Student List</h4>
            </div>
            <div className="col-md-8">
              {permission?.add === 1 ? (
                <Link
                  className="ui button float-end"
                  to="/branch/free/member-add"
                >
                  Add Student
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* <CustomTable columns={columns} data={data} /> */}
          <CustomTable columns={columns} data={data} search={true} />
        </>
      ) : (
        <DataLoader />
      )}
    </div>
  );
};

export default Student_enroll_list;
